import React from 'react';
import Button from 'common/general/Button';
import { VIEW_PI_REVIEW, VIEW_SM_REVIEW } from 'constants/userOperations';
import { userHasAccessTo } from 'services/auth';

import { generateUrlByKey, useCurrentRoute } from '../../../../../../../../../root/router';
import { useEncounterSegment } from '../EncounterSegment';

export default function HeaderReview() {
  const currentRoute = useCurrentRoute();
  const { encounter } = useEncounterSegment();
  const patientId = currentRoute.params?.patientId;
  const ssuPatientId = currentRoute.params?.ssuPatientId;
  const { sitePatientEncounter } = encounter;

  const url = generateBeginReviewUrl();

  return (
    <Button size="h28" disabled={!url} to={url}>
      Begin Review
    </Button>
  );

  function generateBeginReviewUrl() {
    const {
      id: patientEncounterId,
      encounterStatus,
      smGroupAssignId,
      investigatorGroupAssignId
    } = sitePatientEncounter;

    if (!userHasAccessTo(resolveByEncounterStatus(VIEW_SM_REVIEW, VIEW_PI_REVIEW))) {
      return null;
    }

    if (resolveByEncounterStatus(!smGroupAssignId, !investigatorGroupAssignId)) {
      return null;
    }

    return generateUrlByKey(
      `${currentRoute.key}.Encounter Details.${resolveByEncounterStatus(
        `Study Manager Encounter Review`,
        `Investigator Encounter Review`
      )}`,
      {
        patientId,
        ssuPatientId,
        patientEncounterId,
        groupAssignId: resolveByEncounterStatus(smGroupAssignId, investigatorGroupAssignId),
        signatureId: 'current'
      }
    );

    function resolveByEncounterStatus(a, b) {
      return {
        SM_REVIEW: a,
        PI_REVIEW: b
      }[encounterStatus];
    }
  }
}
